import { createContext, useContext } from 'react';
export const NamedQueryContext = createContext({
    namedQuery: false,
    setNamedQuery: () => { },
    //  hasValidNamedQueryName: () => false,
});
export const useNamedQueryContext = () => {
    return useContext(NamedQueryContext);
};
